<template>
  <div v-if="roomId" :class="className" :style="genStyle()">
    <a v-if="className === 'stop' && isFromAdmin" :href="reservationPath + id" :title="blockReason">
      <span class="block-reason-text">{{ `休止中(${truncatedBlockReason})` }}</span>
    </a>
    <span v-else-if="className === 'stop' && !isFromAdmin" :title="blockReason" class="block-reason-text">
      {{ `休止中(${truncatedBlockReason})` }}
    </span>
    <a v-if="className === 'requested'" :href="reservationPath + id">
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#950008"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        [未承認] {{ start }} 〜 {{ end }}
      </span>
      <span>{{ userName }}</span>
    </a>
    <a v-if="className === 'stay'" :href="reservationPath + id">
      <span>{{ start }}～{{ end }}</span>
      <span>{{ userName }}</span>
    </a>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      required: true,
    },
    roomId: {
      type: Number,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
    checkInDate: {
      type: String,
      required: true,
    },
    checkOutDate: {
      type: String,
      required: true,
    },
    blockReason: {
      type: String,
      default: null,
    },
    calendar: {
      type: Array,
      required: true,
    },
    rooms: {
      type: Array,
      required: true,
    },
    reservationPath: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      row: 0,
      column: 1,
      span: 0,
      start: '',
      end: '',
    }
  },
  computed: {
    isFromAdmin() {
      return this.reservationPath.startsWith('/admin')
    },
    truncatedBlockReason() {
      if (!this.blockReason) return ''
      const maxLength = 15
      if (this.blockReason.length <= maxLength) {
        return this.blockReason
      }
      return this.blockReason.substring(0, maxLength) + '...'
    },
  },
  mounted: function () {
    this.setRow(this.rooms)
    this.setColumn(this.checkInDate, this.calendar)
    this.setSpan(this.checkInDate, this.checkOutDate, this.calendar)
    this.setDate(this.checkInDate, this.checkOutDate)
  },
  methods: {
    setRow(rooms) {
      if (!this.roomId) {
        this.row = rooms.length + 1
      } else {
        rooms.map((r, i) => {
          if (this.roomId == r.id) {
            this.row = i + 1
          }
        })
      }
    },
    setColumn(checkInDate, calendar) {
      /* check_in_date を判定して grid-column スタート位置 */
      calendar.map((c, i) => {
        if (c.date == checkInDate) {
          // Columns are 1 (check-in is off-window to the left) and
          // 2..calendar.length+1 for the visible days -- i.e. with a 7-day
          // window, column 2 is the first day and column 8 is the LAST day.
          // There is no off-window column on the right; misreading column 8 as
          // one is what let bars be placed past the end of the grid.
          this.column = i + 2
        }
        /* default = 1(枠外) */
      })
    },
    setSpan(checkInDate, checkOutDate, calendar) {
      let span
      if (this.column === 1) {
        /* check_in_date が枠外の場合 */
        span = dayjs(checkOutDate).diff(dayjs(calendar[0].date), 'day') + 1
      } else {
        /* check_in_date ~ check_out_date が 何日間か span */
        span = dayjs(checkOutDate).diff(dayjs(checkInDate), 'day')
      }
      // Clamp the bar so it never reaches past the last grid column.
      // Columns are 1 (off-window bleed) + calendar.length days, so the last
      // usable column is calendar.length + 1. The previous cap only limited the
      // span itself, not `column + span`, so a stay checking in on the last
      // visible day (column 8) was placed across columns 8-15 -- blowing the
      // calendar up to ~2x its container. Because .yamori-calendar is
      // overflow-hidden, that made it a silently scrollable box: any focus
      // restore scrolled it and pushed the pagination arrows out of sight with
      // no way to scroll back.
      // A span below 1 is also invalid CSS (it drops grid-column entirely and
      // the bar gets auto-placed in a random cell), so floor it at 1.
      const lastColumn = this.calendar.length + 1
      this.span = Math.min(Math.max(span, 1), lastColumn - this.column + 1)
    },
    setDate(checkInDate, checkOutDate) {
      this.start = dayjs(checkInDate).format('M/D')
      this.end = dayjs(checkOutDate).format('M/D')
    },
    genStyle() {
      // 'grid-row: ' + row + ' / ' + (row + 1) + '; grid-column: ' + column + ' / span ' + span + ';'

      let styles = []
      // Grid Position | Size
      styles.push(`grid-row: ${this.row} / ${this.row + 1};`)
      styles.push(`grid-column: ${this.column} / span ${this.span};`)

      // Indent text when outter space
      if (this.column == 1) {
        // To avoid Infinity
        // The ratio function is 100%[width] / this.span[size] * (4 / 5)[positon]
        let ratio = 0
        switch (this.span) {
          case 1:
            ratio = 60
            break
          case 2:
            ratio = 30
            break
          case 3:
            ratio = 20
            break
          case 4:
            ratio = 15
            break
          case 5:
            ratio = 12
            break
          case 6:
            ratio = 10
            break
          case 7:
            ratio = 8.57
            break
          case 8:
            ratio = 7.5
            break
        }
        styles.push(`padding-left: calc(${ratio}%)`)
      }

      return styles.join(' ')
    },
  },
}
</script>
